import { type FieldError } from 'react-hook-form-5'
import { useCallback } from 'react'
import { type DashMessages } from '../../intl/intl.types'
import { type FormValidationType, type FormErrorMessageMap } from './reactHookForm.types'

export const useFormErrorMessageMap = <T extends string = DashMessages>(
  mapping: FormErrorMessageMap<T>
) =>
  useCallback(
    (fieldError?: FieldError) => {
      if (!fieldError) return undefined

      const errorType = fieldError.type as FormValidationType

      return mapping[errorType]
    },
    [mapping]
  )
